import Navbar from "../Components/Navbar";
import SkillSet from "../Components/SkillSet";
import Footer from "../Components/Footer";
const Skills=()=>{
    return(
        <div>
           <Navbar />
           <SkillSet/>
           <Footer />
        </div>
    )
}
export default Skills;